import React from 'react';
import { Button, type ButtonProps } from '../../shadcn/Button';
import Image from '../Image';
import Link from '../Link';
import { cn } from '../../../tailwind-base/utils';

import type { SanityDeptCta } from '../../../models/gatsby-graphql-types';

interface Props extends ButtonProps {
  cta?: SanityDeptCta;
  customIcon?: React.ReactNode;
}

const CTAButton = ({
  cta,
  customIcon,
  variant = 'cta',
  ...rest
}: Readonly<Props>) => {
  if (!cta?.text) return null;

  const isDisabled = /disable/i.test(
    typeof cta.link === 'string' ? '' : cta.link?.linkType ?? ''
  );

  return (
    <Button
      asChild
      className={cn(
        'no-underline text-base text-center font-semibold py-4 px-6',
        !isDisabled ? 'cursor-pointer' : 'cursor-not-allowed'
      )}
      disabled={isDisabled}
      variant={variant}
      {...rest}
    >
      <Link
        className="items-center gap-2 text-inherit no-underline hover:no-underline"
        link={cta.link}
      >
        {customIcon}
        {cta.icon && !customIcon && (
          <Image
            alt={cta.icon.asset.altText || 'image'}
            className="fill-white"
            sanityImage={cta.icon}
            src={cta.icon.asset.url || 'image'}
            srcSetBasisWidth={40}
            width="1.6rem"
          />
        )}
        {cta.text}
      </Link>
    </Button>
  );
};

export default CTAButton;
